var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Report',{attrs:{"config":{
        type:'overspeed',
        dataSources:[
          {
            'name':'devices',
            'type':'dynamic',
            'component':'DeviceDataSource',
            'config':{
              'label':'Devices'
            }
          }
        ],
        parameters:[
            {
              'type':'stmSelect',
              'id':'devices',
              'config':{
                'label':'Devices',
                'key':'devices',
                'selectionKey':'device_id',
                'options':'devices',
                'multiple':true,
                'allOption':true,
              }
            },
            {
              'type':'dateTimeRange',
              'id':'range',
              'config':{
                'label':'time',
                'startKey':'from',
                'endKey':'to'
              }
            } ],
      exports:[
        {
          'label':'pdf',
          'export':'overspeedReport',
          'exporter':'pdf'
        },
        {
          'label':'excel',
          'export':'overspeedReport',
          'exporter':'xlsx'
        }
      ],
      table:{
        'type':'default',
        'config':{
          'fields':[
            {
              key:'id',
              label:'#'
            },
            {
              key:'owner',
              label:'Owner'
            },
            {
              key:'contract',
              label:'Contract'
            },
            {
              key:'category',
              label:'Category',
              formatter:function (value){
                return _vm.$t(value)
              }
            },
            {
              key:'device',
              label:'Device'
            },
            {
              key:'time',
              label:'Time'
            },
            {
              key:'speed',
              label:'Speed'
            },
            {
              key:'speedLimit',
              label:'Speed Limit'
            }
          ]
        }
      }
  }}})}
var staticRenderFns = []

export { render, staticRenderFns }